import { useQueries } from '@tanstack/react-query'
import { integrationQueryOptions } from '../../queries'

export function useIntegrations({ integrationIds, workspaceId }: { integrationIds: string[]; workspaceId: string }) {
  const results = useQueries({
    queries: integrationIds.map((integrationId) => integrationQueryOptions({ integrationId, workspaceId })),
  })

  return results.reduce(
    (acc, result) => {
      if (result.status === 'success' && result.data) {
        acc.push(result.data)
      }
      return acc
    },
    [] as Array<NonNullable<(typeof results)[number]['data']>>
  )
}
